import React from "react";
import RelatedPaymentTooltip from "Components/Pages/UserProfile/UserPayments/RelatedPaymentTableCell/RelatedPaymentTooltip/RelatedPaymentTooltip";
import { DPEmployeePayment } from "Shared/types/Payments";
import TableCell from "@material-ui/core/TableCell";
import createPaySpan from "Components/Pages/UserProfile/UserPayments/RelatedPaymentTableCell/createPaySpan/createPaySpan";
import useStyles from "./styles";

const RelatedPaymentTableCell = (payment: DPEmployeePayment) => {
  const paySpan = createPaySpan(payment);

  const classes = useStyles();

  return paySpan ? (
    <TableCell className={classes.buttonCell} align="center">
      <RelatedPaymentTooltip {...paySpan} />
    </TableCell>
  ) : (
    <TableCell />
  );
};

export default RelatedPaymentTableCell;
